import { ConfigType } from '../utils/requestAPI';

type BankAccountDataType = {
  accountNumber: string;
  addressLine: string;
  bankName: string;
  city: string;
  email: string;
  name: string;
  postalCode: string;
  state: string;
};
// type CreditCardDataType = {
//   display_brand: string;
//   last4: string;
//   exp_month: number;
//   exp_year: string;
//   funding: string;
//   customerId: string;
// };

const paymentApi = {
  addBankAccount: (data: BankAccountDataType): ConfigType => {
    return {
      url: '/payment',
      method: 'post',
      data: data,
    };
  },
  createPaymentIntentSetup: (): ConfigType => {
    return {
      url: '/stripe/setup-intent',
      method: 'post',
    };
  },

  addCreditCard: (data: any): ConfigType => {
    return {
      url: '/card',
      method: 'post',
      data: data,
    };
  },
  addBankAcc: (): ConfigType => {
    return {
      url: '/stripe/setup-express',
      method: 'post',
    };
  },

  getCards: (): ConfigType => {
    return {
      url: '/stripe/cards',
      method: 'get',
    };
  },
  getBankAccounts: (): ConfigType => {
    return {
      url: '/stripe/bank-accounts',
      method: 'get',
    };
  },
  deleteCards: (): ConfigType => {
    return {
      url: '/card',
      method: 'delete',
    };
  },
};

export default paymentApi;
